import React, {Component} from 'react';
import {Row, Col } from "reactstrap";
import {inject, observer} from "mobx-react/index";
import CardDetalhe from "../../../comum/components/CardDetalhe";
import {listEmailFormatter} from "../../../../utils/formatar"

@inject("store")
@observer
export default class DetalhesCabotagem extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return(
            <Col xs={12} className="container-card-detalhe">
                <div className="pb-3 pt-3">
                    <h4>{this.props.titulo}</h4>
                    <Row className="m-0 no-gutters">
                        <Col sm={4}>
                            <CardDetalhe titulo={"Cliente"}
                                         desc={[this.props.row.Cliente]}
                                         pt="pt-2"
                                         pb="pb-2"
                            />
                        </Col>
                        <Col sm={4}>
                            <CardDetalhe titulo={"Criado por"}
                                         desc={[this.props.row.UsuarioCadastro]}
                                         pt="pt-2"
                                         pb="pb-2"
                            />
                        </Col>
                        <Col sm={4}>
                            <CardDetalhe titulo={"Inativado por"}
                                         desc={[this.props.row.UsuarioInativou]}
                                         pt="pt-2"
                                         pb="pb-2"
                                         />
                        </Col>
                        <Col sm={4}>
                            <CardDetalhe titulo={"Email"}
                                         desc={[this.props.row.Email]}
                                         pt="pt-2"
                                         pb="pb-2"
                            />
                        </Col>
                        <Col sm={8}>
                            <CardDetalhe titulo={"Observação"}
                                         desc={[this.props.row.Observacao]}
                                         pt="pt-2"
                                         pb="pb-2"
                            />
                        </Col>
                    </Row>
                </div>
            </Col>)
    }
}


// WEBPACK FOOTER //
// ./src/modules/liberacoes/cabotagem/components/DetalhesCabotagem.js